import { render } from "./SavingDetailPage.vue?vue&type=template&id=620739f0&scoped=true"
import script from "./SavingDetailPage.vue?vue&type=script&lang=js"
export * from "./SavingDetailPage.vue?vue&type=script&lang=js"

import "./SavingDetailPage.vue?vue&type=style&index=0&id=620739f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-620739f0"

export default script